import { Button } from "@progress/kendo-react-buttons";
import { Typography } from "@progress/kendo-react-common";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  deletePartAddtoOrders,
  findAllPartAddtoOrders,
} from "./services/ghat.services";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import {
  clearFilterPartAddtoOrders,
  clearPartAddtoOrdersDetail,
  setFilterPartAddtoOrders,
  setPartAddtoOrdersID,
} from "./partAddtoOrdersSlice";
import {
  CompositeFilterDescriptor,
  filterBy,
} from "@progress/kendo-data-query";
import {
  GridCustomCellProps,
  GridCustomHeaderCellProps,
  GridFilterChangeEvent,
  GridPageChangeEvent,
  Grid as KendoGrid,
  GridColumn as Column,
  GridCustomFilterCellProps,
} from "@progress/kendo-react-grid";
import { HeaderThElement } from "@progress/kendo-react-data-tools";
import IconButton from "../../components/common/IconButton";
import { FiEdit } from "react-icons/fi";
import { MdDelete } from "react-icons/md";
import { LoadingPanel } from "../../components/layout/Loading";
import { setCurrentPage, setPageLimit } from "../pagination/paginationSlice";
import { checkAcessRights } from "../../_helper/helper";
import {
  DELETE_ACCESS,
  EDIT_ACCESS,
  INSERT_ACCESS,
  PRINT_ACCESS,
} from "../../_contstants/common";
import CommonFilterCell from "../../components/common/GlobalCommonFilterCell";
import moment from "moment";

const PartAddtoOrders: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const isAddAccess = checkAcessRights(location.pathname, INSERT_ACCESS);

  useEffect(() => {
    return () => {
      dispatch(closeDialog());
      dispatch(clearPartAddtoOrdersDetail());
      dispatch(setCurrentPage(0));
    };
  }, []);

  const handleProcessCreate = () => {
    navigate("/partaddtoorders/create");
  };

  return (
    <>
      <DeletePartAddtoOrdersDialog />
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "4px 20px 20px 0",
          }}
        >
          <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
            Part Add to Orders List
          </Typography.h4>
          {isAddAccess && (
            <Button
              onClick={handleProcessCreate}
              fillMode={"solid"}
              themeColor={"primary"}
            >
              Add New
            </Button>
          )}
        </GridLayoutItem>
        <GridLayoutItem>
          <PartAddtoOrdersGridComponent />
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

const PartAddtoOrdersGridComponent: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);
  const PartAddtoOrdersList = useAppSelector(
    (state) => state.partAddtoOrders.PartAddtoOrdersList,
  );
  const loading = useAppSelector((state) => state.partAddtoOrders.loading);
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);
  const isEditAccess = checkAcessRights(location.pathname, EDIT_ACCESS);
  const isDeleteAccess = checkAcessRights(location.pathname, DELETE_ACCESS);
  const isPrintAccess = checkAcessRights(location.pathname, PRINT_ACCESS);
  const FilterPartAddtoOrders = useAppSelector(
    (state) => state.partAddtoOrders.FilterPartAddtoOrders,
  );

  useEffect(() => {
    const payload = {
      ...FilterPartAddtoOrders,
      limit: +pageLimit,
      skip: +currentPage * +pageLimit,
    };
    dispatch(findAllPartAddtoOrders(payload));
  }, [currentPage, pageLimit, dispatch]);

  const pageChange = (event: GridPageChangeEvent) => {
    const newPage = event.page.skip / event.page.take;
    dispatch(setPageLimit(event.page.take));
    dispatch(setCurrentPage(newPage));
  };

  const [filter, setFilter] = React.useState<
    CompositeFilterDescriptor | undefined
  >(undefined);

  const MyEditCommandCell = (props: any) => {
    const handleEditItem = (ID: number) => {
      navigate("/partaddtoorders/edit", {
        state: { ID, PartAddtoOrderNo: props.dataItem?.ID },
      });
    };

    // const handlePrint = (ID: number) => {
    //   window.open(`/partaddtoorders/${ID}`, "_blank");
    // };

    const handleOpenDeleteDialog = (ID: number) => {
      dispatch(openDialog("deletePartAddtoOrders"));
      dispatch(setPartAddtoOrdersID(ID));
    };

    return (
      <td
        {...props.tdProps}
        className={`action-td ${props.className}`}
        style={{ ...props.tdProps.style }}
      >
        {isEditAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Edit"
            themeColor="success"
            onClick={() => handleEditItem(props.dataItem.ID)}
          >
            <FiEdit
              className="absolute-position"
              style={{ fontSize: "20px" }}
            />
          </IconButton>
        )}
        {isDeleteAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Delete"
            themeColor="error"
            onClick={() => handleOpenDeleteDialog(props.dataItem.ID)}
          >
            <MdDelete
              className="absolute-position"
              style={{ fontSize: "24px" }}
            />
          </IconButton>
        )}
        {/* {isPrintAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="View"
            themeColor="tertiary"
            onClick={() => handlePrint(props.dataItem.ID)}
          >
            <FaEye className="absolute-position" style={{ fontSize: "24px" }} />
          </IconButton>
        )} */}
      </td>
    );
  };

  const handleFilterChange = (e: GridFilterChangeEvent) => {
    setFilter(e.filter);
  };

  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className={`table-header ${props.index === 4 ? "locked-header" : ""}`}
    >
      {props.children}
    </HeaderThElement>
  );

  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };
  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  const PartAddtoOrdersFilterCell = React.useCallback(
    (props: GridCustomFilterCellProps) => (
      <CommonFilterCell
        {...props}
        filterSelector={(state) => state.partAddtoOrders.FilterPartAddtoOrders}
        setFilterAction={setFilterPartAddtoOrders}
        clearFilterAction={clearFilterPartAddtoOrders}
        fetchDataAction={findAllPartAddtoOrders}
        pagination={{ case: "lowercase" }}
      />
    ),
    [],
  );

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <KendoGrid
        scrollable="scrollable"
        className="responsive-table"
        style={{ maxHeight: "calc(100vh - 152px)" }}
        filterable={true}
        filter={filter}
        data={
          filter ? filterBy(PartAddtoOrdersList, filter) : PartAddtoOrdersList
        }
        total={PartAddtoOrdersList[0]?.itemcount || PartAddtoOrdersList.length}
        onFilterChange={handleFilterChange}
        skip={currentPage * pageLimit}
        take={pageLimit}
        pageable={{
          buttonCount: 5,
          pageSizes: [10, 50, 100, 300, 500],
          pageSizeValue: pageLimit,
          type: "input",
        }}
        onPageChange={pageChange}
        cells={{
          headerCell: HeaderCustomCell,
          data: MyDataCustomCell,
        }}
      >
        <Column
          width={100}
          field="PartAddtoOrderNo"
          title="No"
          cells={{
            data: (props: any) => (
              <td>
                <div
                  className="hoverableName"
                  onClick={() =>
                    navigate("/partaddtoorders/edit", {
                      state: {
                        ID: props.dataItem?.ID,
                        PartAddtoOrderNo: props.dataItem?.ID,
                      },
                    })
                  }
                >
                  {props.dataItem?.PartAddtoOrderNo}
                </div>
              </td>
            ),
            filterCell: PartAddtoOrdersFilterCell,
          }}
        />
        <Column
          field="OrderNo"
          title="Order No"
          width={100}
        />
        <Column
          field="order_date"
          title="Order Date"
          width={150}
          cells={{
            data: (props: any) => (
              <td>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {props.dataItem.order_date || "-"}
                </div>
              </td>
            ),
          }}
        />
        <Column
          field="Date"
          title="Date"
          width={150}
          cells={{
            data: (props: any) => (
              <td>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {props.dataItem.Date
                    ? moment(props.dataItem.Date, "2026-03-25").format(
                        "DD/MM/YYYY",
                      )
                    : "-"}
                </div>
              </td>
            ),
          }}
        />
        <Column
          field="ProductName"
          title="Product Name"
          width={200}
          cells={{
            filterCell: PartAddtoOrdersFilterCell,
          }}
        />
        <Column field="Remarks" title="Remarks" />
        {(isEditAccess || isDeleteAccess || isPrintAccess) && (
          <Column
            field="ID"
            title="Actions"
            cells={{ data: MyEditCommandCell }}
            width={"150px"}
            filterable={false}
            locked={true}
          />
        )}
      </KendoGrid>
    </>
  );
};

const DeletePartAddtoOrdersDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const PartAddtoOrdersID = useAppSelector(
    (state) => state.partAddtoOrders.PartAddtoOrdersID,
  );
  const FilterPartAddtoOrders = useAppSelector(
    (state) => state.partAddtoOrders.FilterPartAddtoOrders,
  );
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);

  const handleDeleteAction = async (ID: number | null) => {
    const getpayload = {
      ...FilterPartAddtoOrders,
      limit: +pageLimit,
      skip: +currentPage * +pageLimit,
    };
    if (ID) {
      const response = await dispatch(deletePartAddtoOrders({ ID }));
      dispatch(setCurrentPage(0));
      if (response.payload?.Data?.Status === 200) {
        dispatch(findAllPartAddtoOrders(getpayload));
        dispatch(closeDialog());
        dispatch(clearPartAddtoOrdersDetail());
      } else {
        dispatch(findAllPartAddtoOrders(getpayload));
        dispatch(closeDialog());
        dispatch(clearPartAddtoOrdersDetail());
      }
    }
  };

  return (
    <>
      {dialogName === "deletePartAddtoOrders" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Part Addto Order?"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this Part Addto Order?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => {
                    handleDeleteAction(PartAddtoOrdersID);
                  }}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

export default PartAddtoOrders;
